import * as React from "react";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import {
  TabbedNavigation,
  TabOptions
} from "src/library/components/TabbedNavigation/TabbedNavigation";
import { PageProps } from "src/pages/Router/routes";

import AccountingPageTab from "./AccountingPageTab";

const AccountingPage: React.FC<PageProps<unknown>> = props => {
  const tabTypes = React.useMemo(() => [
    {
      type: "invoices" as const,
      title: "Outstanding Invoices"
    },
    {
      type: "transactions" as const,
      title: "Transactions"
    }
  ], []);

  const tabs: TabOptions[] = React.useMemo(() => {
    return tabTypes.map(tabConfig => ({
      title: tabConfig.title,
      name: tabConfig.type,
      content: () => (
        <AccountingPageTab tabType={tabConfig.type} />
      )
    }));
  }, [ tabTypes ]);

  return (
    <Layout {...props}>
      <MainContentWrapper>
        <div>

          <TabbedNavigation
            tabs={tabs}
            defaultTab="invoices"
          />
        </div>
      </MainContentWrapper>
    </Layout>
  );
};

export default AccountingPage;
